import { notification } from "antd";
import { ApolloError } from "apollo-boost";
import { action, computed, makeAutoObservable } from "mobx";
import { Api } from "../../../common/Api";
import { RegionsStore } from "./RegionsStore";

export class DivisionEditStore {
  store: RegionsStore;

  visible = false;
  saving = false;
  model?: any;

  constructor(store: RegionsStore) {
    makeAutoObservable(this, {
      store: false,
      directors: computed,
    });
    this.store = store;
  }

  get directors() :any[] {
    return []// this.store.rootStore.employeeStore.employees.filter((x) => x.roles.includes("Division Director"));
  }

  @action
  async edit(model) {
    const { id, name, regionId, zoneId, directorId, directorIds } = model;

    this.model = { id, name, regionId, zoneId, directorId, directorIds };
    this.visible = true;
    // this.store.rootStore.employeeStore.refresh();
  }

  @action
  save(values) {
    this.saving = true;
    return Api.division
      .save({ id: this.model.id, ...values })
      .then((res) => {
        this.visible = false;
        notification.success({ message: `Division ${values.name} saved` });
        this.store.refresh();
      })
      .catch((err: ApolloError) => {})
      .finally(() => (this.saving = false));
  }

  @action
  close() {
    this.visible = false;
  }
}
